<template>
  <div class="class-management">
    <el-button size="mini" @click="OpenDialog">选择讲次</el-button>

    <el-dialog
      title="选择插入讲次"
      :visible.sync="dialogVisible1"
      width="80%"
      append-to-body
    >
      <el-form size="mini" :inline="true" ref="ruleForm" :model="ruleForm">
        <el-form-item label="课程类型">
          <el-radio-group
            v-model="ruleForm.curriculum_type"
            @change="getCampusCurriculumtListByPage"
          >
            <el-radio label="">全部</el-radio>
            <el-radio label="1">体验课</el-radio>
            <el-radio label="2">常规课</el-radio>
            <el-radio label="3">短期课</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div>
        <el-row :gutter="20">
          <el-col :span="12"
            ><div>
              <el-table
                :data="curriculum_list"
                :header-cell-style="{ background: '#f5f7fa' }"
                size="mini"
                highlight-current-row
                @current-change="handleCurrentChange1"
                height="400px"
                style="
                  width: 100%;
                  border-left: 1px solid #f5f7fa;
                  border-right: 1px solid #f5f7fa;
                  border-top: 1px solid #f5f7fa;
                "
              >
                <el-table-column
                  align="left"
                  width="180"
                  label="封面"
                >
                  <template slot-scope="scope">
                    <el-image
                      style="width: 150px; height: 68px"
                      :src="scope.row.curriculumInfo.img_url"
                      fit="cover"
                    ></el-image>
                  </template>
                </el-table-column>

                <el-table-column
                  align="left"
                  prop="curriculumInfo.title"
                  label="课程名称"
                ></el-table-column>

                <el-table-column
                  align="left"
                  prop="curriculumInfo.curriculum_desc"
                  label="简介"
                ></el-table-column>
              </el-table></div
          ></el-col>
          <el-col :span="12"
            ><div>
              <el-table
                :data="curriculumMaterialList"
                :header-cell-style="{ background: '#f5f7fa' }"
                size="mini"
                highlight-current-row
                @current-change="handleCurrentChange"
                height="400px"
                style="
                  width: 100%;
                  border-left: 1px solid #f5f7fa;
                  border-right: 1px solid #f5f7fa;
                  border-top: 1px solid #f5f7fa;
                "
              >
                <el-table-column width="100" align="center" label="讲次序号">
                  <template slot-scope="scope">
                    第{{ scope.$index + 1 }}讲
                  </template>
                </el-table-column>

                <el-table-column
                  align="center"
                  width="100"
                  prop="id"
                  label="缩略图"
                >
                  <template slot-scope="scope">
                    <el-image
                      style="width: 60px; height: 45px"
                      :src="scope.row.img_url"
                      fit="cover"
                    ></el-image>
                  </template>
                </el-table-column>

                <el-table-column
                  align="center"
                  prop="title"
                  label="讲次名称"
                ></el-table-column>

                <el-table-column
                  align="center"
                  prop="desc"
                  label="简介"
                  :show-overflow-tooltip="true"
                ></el-table-column>
              </el-table></div
          ></el-col>
        </el-row>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="choosePlan">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCurriculumList,
  getCampusCurriculumtListByPage,
  getPrepareCurrculumMaterialList,
} from "@/api/educational";

export default {
  name: "insertTeachplan",

  props: {
    subject_id: Number,
    campus_id: Number,
  },

  data() {
    return {
      //课程页码管理
      page_no: 1,
      page_size: 100,

      curriculum_title: "", //讲次名称
      dialogVisible: false, //讲次详情列表
      dialogVisible1: false, // 讲次列表;
      curriculumMaterialList: [], //讲次数据列表

      dialogTableVisible: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,

      //搜索正式班级
      ruleForm: {
        subject_id: "",
        teaching_type: "",
        curriculum_type: "",
        curriculum_id: "", //体系id
      },
      school_list: [],

      classStartTime: "",
      subjectList: [],
      tableData: [],
      curriculum_list: [],
      total: 0,

      //学员续班

      activeName: "first", //正式学员列表

      current_class_id: "",
      choosePlanInfo: {}, //所选讲次信息
    };
  },
  mounted() {
    if (this.$store.state.user.selected_schools.length == 0) {
      this.$message.warning("请选择校区");
    } else {
      this.getCampusCurriculumtListByPage();
      this.ruleForm.subject_id = "";
    }
  },
  watch: {
    "$store.state.user.selected_schools": {
      handler(newValue) {
        console.log("校区监听");

        if (newValue.length == 0) {
          this.$message.warning("请选择校区");
        } else {
          this.getCampusCurriculumtListByPage();
        }
      },
      deep: true,
    },
  },
  methods: {
    OpenDialog() {
      this.dialogVisible1 = true;
    },

    getCurriculumList(val) {
      this.ruleForm.curriculum_id = "";
      getCurriculumList({
        subject_id: val,
        page_size: 100,
      }).then((res) => {
        this.curriculum_list = res.curriculum_list;
        console.log("课程体系详情");
        console.log(this.curriculum_list);
      });
    },
    search() {
      this.getPrepareCurrculumMaterialList(this.ruleForm.curriculum_id);
    },

    //获得讲次
    getPrepareCurrculumMaterialList(id) {
      if (!id) {
        this.$message.warning("请选择所属课程");
        return;
      }

      getPrepareCurrculumMaterialList({
        curriculum_id: id,
      }).then((res) => {
        console.log("课程详情");
        console.log(res);
        this.curriculumMaterialList = res.curriculumMaterialList;
      });
    },

    prepare(id) {
      this.$router.push({
        name: "prepare",
        query: {
          curriculumMaterial_id: id,
          backname: "course-list",
        },
      });
    },

    //讲次传值
    choosePlan() {

      console.log(this.choosePlanInfo);

      if (this.choosePlanInfo.id) {
        this.$emit("choosePlan", this.choosePlanInfo);
        this.dialogVisible1 = false;
      } else {
        this.$message.warning("请选择插入讲次");
      }
    },

    //获取学校公开课课程体系
    getCampusCurriculumtListByPage() {
      this.curriculum_list = [];

      console.log("获取学校课程体系");
      console.log(this.ruleForm);

      getCampusCurriculumtListByPage({
        campusIds: JSON.stringify([this.campus_id]),
        subjectId: this.subject_id,
        teaching_type: this.ruleForm.teaching_type,
        curriculum_type: this.ruleForm.curriculum_type,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log("获取学校课程体系");
        console.log(res);
        this.curriculum_list = res.campusAuthList;
        this.total = res.total;
      });
    },

    handleCurrentChange(val) {
      console.log("选中讲次");
      console.log(val);
      this.choosePlanInfo = val;
    },

    handleCurrentChange1(val) {
      console.log("选中课程体系");
      console.log(val);
      this.getPrepareCurrculumMaterialList(val.curriculum_id);
    },

    reSize() {
      this.page_no = 1;

      this.ruleForm = {
        subject_id: "",
        teaching_type: "",
        curriculum_type: "",
      };
      this.getCampusCurriculumtListByPage();
    },
  },
};
</script>

<style lang="scss" scoped>
.class-management {
  height: 100%;
  border-radius: 5px;
  box-sizing: border-box;
  background-color: #fff;
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
    padding-right: 5px;
  }
  .setting {
    float: right;
  }
}
</style>
